import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    title: "标题",
    message: "（空）",
    buttons: [],
    show: false
}

// mutations
const mutations = {
    hide(state) {
        state.show = false;
    },
    show(state, { title, message, buttons = [] }) {
        state.title = title;
        state.message = message;
        state.buttons = buttons;
        if (state.buttons.length == 0) {
            state.buttons = [{ label: "确定" }];
        }
        state.show = true;
    }
}

export default {
    namespaced: true,
    state,
    //    getters,
    //    actions,
    mutations
}